export default __webpack_public_path__ + "img/a2ae84cb36ee843f3785314808690c96.svg";